import React from 'react';
import { ConsentWrapper } from '@pinggolf/ping-com-ui-components';
import { IConsentManagerConfig, DEFAULT_ONETRUST_MAPPINGS } from '@pinggolf/ping-com-ui-component-types';
import './segment';

interface ConsentWrapperProps {
    children: React.ReactNode;
}

export const ConsentManagementWrapper: React.FC<ConsentWrapperProps> = ({ children }) => {

    const oneTrustConfig: IConsentManagerConfig = {
        oneTrustDomainScript: process.env.REACT_APP_ONETRUST_DOMAIN_SCRIPT as string,
        tools: {
            segment: {
                name: 'segment',
                enabled: true,
                configuration: {
                    importURL: 'https://cdn.segment.com/analytics.js',
                    codeMap: {
                        writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY || ''
                    },
                    keyOf: 'writeKey',
                    component: 'segment',
                    consentCategory: ['C0002', 'C0004']
                }
            }
        },
        mappings: DEFAULT_ONETRUST_MAPPINGS,
        defaultConsentModel: 'opt-in'
    };

    return (
        <ConsentWrapper
            useOneTrust={true}
            config={oneTrustConfig}
        >
            {children}
        </ConsentWrapper>
    );
}